import BLOCK_GAP from 'src/constants/blockGap';
import { Block } from 'src/types/shared/blocksV3';
import { getOppositeEdge } from './edgeUtils';
import BlockType from 'src/enums/blockType';

export function getBlockInitialPosition(
	parentBlock: Block,
	block: Block,
	scaleFactor: number
) {
	if (!parentBlock || !block) {
		return {
			x: 0,
			y: 0,
		};
	}

	if (block.type == BlockType.BUMPOUT)
		return getBumpoutInitialPosition(parentBlock, block, scaleFactor);

	const edgeAttachedToParent = block.edges.find(
		(edge) => edge.attachedToParent
	);

	const edgeAttachedToChild = parentBlock.edges.find(
		(edge) => edge.label == getOppositeEdge(edgeAttachedToParent?.label)
	);

	const attachedSegmentIndex =
		edgeAttachedToChild?.segments.findIndex(
			(segment) => segment.id == block.parentBlock.segmentId
		) || 0;

	let blockOffset =
		attachedSegmentIndex > 0
			? edgeAttachedToChild?.segments
					.slice(0, attachedSegmentIndex)
					.reduce((acc, segment) => {
						return acc + segment.length;
					}, 0)
			: 0;

	blockOffset = blockOffset || 0;

	let position;

	switch (edgeAttachedToParent?.label) {
		case 'Top':
			position = {
				x: (parentBlock.position?.x || 0) + blockOffset * scaleFactor,
				y:
					(parentBlock.position?.y || 0) +
					parentBlock.displayDimensions.height * scaleFactor +
					BLOCK_GAP,
			};
			break;
		case 'Bottom':
			position = {
				x: (parentBlock.position?.x || 0) + blockOffset * scaleFactor,
				y:
					(parentBlock.position?.y || 0) -
					block.displayDimensions.height * scaleFactor -
					BLOCK_GAP,
			};
			break;
		case 'Left':
			position = {
				x:
					(parentBlock.position?.x || 0) +
					parentBlock.displayDimensions.width * scaleFactor +
					BLOCK_GAP,
				y: (parentBlock.position?.y || 0) + blockOffset * scaleFactor,
			};
			break;
		case 'Right':
			position = {
				x:
					(parentBlock.position?.x || 0) -
					block.displayDimensions.width * scaleFactor -
					BLOCK_GAP,
				y: (parentBlock.position?.y || 0) + blockOffset * scaleFactor,
			};
			break;
	}

	return position;
}

export function getBumpoutInitialPosition(
	parentBlock: Block,
	block: Block,
	scaleFactor: number
) {
	const edgeAttachedToParent = block.edges.find(
		(edge) => edge.attachedToParent
	);

	let position;

	switch (edgeAttachedToParent?.label) {
		case 'Top':
			position = {
				x: parentBlock.position?.x || 0,
				y: parentBlock.position?.y || 0,
			};
			break;
		case 'Bottom':
			position = {
				x: parentBlock.position?.x || 0,
				y:
					(parentBlock.position?.y || 0) +
					parentBlock.displayDimensions.height * scaleFactor -
					block.displayDimensions.height * scaleFactor,
			};
			break;
		case 'Left':
			position = {
				x: parentBlock.position?.x || 0,
				y: parentBlock.position?.y || 0,
			};
			break;
		case 'Right':
			position = {
				x:
					(parentBlock.position?.x || 0) +
					parentBlock.displayDimensions.width * scaleFactor -
					block.displayDimensions.width * scaleFactor,
				y: parentBlock.position?.y || 0,
			};
			break;
	}

	return position;
}
